<template>
    <div id="newsletter-form"></div>
</template>

<script>
export default {
    name: "NewsLetterModal",
    mounted() {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);

        script.addEventListener("load", () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: "5264255",
                    formId: "d6d77e6b-a287-4d0d-9757-c85a28173494",
                    target: "#newsletter-form"
                })
            }
        })
    }
}
</script>
